import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const TOUR_STORAGE_KEY = 'securepoint_tour_v1_completed';

const TourContext = createContext(null);

export function TourProvider({ children }) {
  const [run, setRun]             = useState(false);
  const [stepIndex, setStepIndex] = useState(0);

  // Auto-start for first-time users after DOM has settled
  useEffect(() => {
    const completed = localStorage.getItem(TOUR_STORAGE_KEY);
    if (!completed) {
      const t = setTimeout(() => setRun(true), 900);
      return () => clearTimeout(t);
    }
  }, []);

  const startTour = useCallback(() => {
    setStepIndex(0);
    setRun(true);
  }, []);

  const stopTour = useCallback(() => {
    setRun(false);
    localStorage.setItem(TOUR_STORAGE_KEY, 'true');
  }, []);

  const resetTour = useCallback(() => {
    localStorage.removeItem(TOUR_STORAGE_KEY);
    setStepIndex(0);
    setRun(true);
  }, []);

  return (
    <TourContext.Provider value={{ run, setRun, stepIndex, setStepIndex, startTour, stopTour, resetTour }}>
      {children}
    </TourContext.Provider>
  );
}

export function useTour() {
  const ctx = useContext(TourContext);
  if (!ctx) throw new Error('useTour must be used inside TourProvider');
  return ctx;
}
